import React from 'react';
import { Power } from 'lucide-react';
import { KeyboardKeyButton } from 'components';

const VMShutdownButton = (props: any) => (
  <KeyboardKeyButton
    type="button"
    title="Shutdown Virtual Machine"
    aria-label="Shutdown Virtual Machine"
    {...props}
  >
    <Power size={20} aria-hidden={true} />
  </KeyboardKeyButton>
);

export { VMShutdownButton };
